import React, { SFC } from 'react';
import { connect } from 'react-redux';
import { ProductFilters } from '../../redux/products/types';
import StateInterface from '../../redux/types';
import useListingPageUrlState from '../../hooks/ListingPage/useListingPageUrlState';
import { getFiltersForPageType } from '../Overlays/FiltersFlyout/filterValueService';
import { hydrateFilterGroupUrls } from '../../hooks/ListingPage/filterUrlService';
import { StyledSEOLink, StyledSeoLinksContainer } from './SeoLink';

const buildSEOLinks = (filters: ProductFilters[]) =>
    filters.map(filter =>
        filter.links && filter.links.length ? (
            <ul key={filter.name}>
                {filter.links.map(({ name, link }) => (
                    <li key={link}>
                        <StyledSEOLink href={link}>{name}</StyledSEOLink>
                    </li>
                ))}
            </ul>
        ) : null
    );

export const FilterSeoLinks: SFC<{ filters: ProductFilters[] }> = ({ filters }) => {
    const [urlState] = useListingPageUrlState();

    const filtersWithUrls = getFiltersForPageType(filters, urlState.listingPageType).map(filter =>
        hydrateFilterGroupUrls(filter, urlState)
    );

    return <StyledSeoLinksContainer>{buildSEOLinks(filtersWithUrls)}</StyledSeoLinksContainer>;
};

const mapStateToProps = (state: StateInterface): { filters: ProductFilters[] } => {
    const { filters } = state.products;
    return { filters };
};

export default connect(mapStateToProps)(FilterSeoLinks);
